var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex margin-x-n1"},_vm._l((_vm.stepCount),function(step,stepIndex){return _c('div',{key:`wizard-status-tracker-${stepIndex}`,staticClass:"d-flex h-8 margin-x-1",class:{
      'background-gray-mid-light': stepIndex > _vm.currentStepIndex,
      'background-primary': stepIndex < _vm.currentStepIndex,
      pulse: stepIndex === _vm.currentStepIndex,
    },style:({ width: `${100 / _vm.stepCount}%` })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }